import { DISPLAY_HIDE_FOOTER } from '../actionTypes/index';

const initialState = {
	hideFooter: false,
};

const displayHideFooterReducer = (state = initialState, action) => {
	switch (action.type) {
		case DISPLAY_HIDE_FOOTER:
			if(action.payload === true || action.payload === false) {
				return {
					...state,
					hideFooter: action.payload
				}
			} else {
				return state;
			}
		default:
			return state;
	}
};
export default displayHideFooterReducer;